/**
 * Select the last day of the week for a given session
 * Drop down control
 */

import React, {
	useState,
	useEffect,
	useCallback,
} from 'react';

import {
 	useSelector,
 	useDispatch
} from 'react-redux';

import {
	actionSetMessage,
	actionResetMessages
} from 'components/messages/actions.js';

import API from 'services/api.js';
import { URL_SESSION_LAST_DAY_OF_WK } from 'services/urls.js'
import Loading from 'components/loading.js'

import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row';
import { format } from 'date-fns';


export const LastDayOfWkSelect = (props) => {

	const {handleChange, value, cols } = props;
	//const sessionId = useSelector(state => state.sessionId);
	const session = useSelector(state => state.session);
	const [columns, setColumns] = useState([]);//	local data for graph or report
	const [loading, setLoading] = useState(false);//	local data for graph or report
	const [today, setToday] = useState(null);
	const dispatch = useDispatch()

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	)
	//console.log('today', today)
	useEffect(() => {
		dispatch(actionResetMessages())
		setToday(format(new Date(), 'yyyy-MM-dd'))
		async function fetchData() {
			const resp = await actionFetchLastDayOfWkData(session, showMessage, setLoading)

			setColumns(resp)
			//console.log('responseData debug', resp)
		}
		if (session.SessionID > 0){
			setLoading(true)
			fetchData();
		}

	},[session, showMessage, dispatch])

	if (columns === undefined){
		const msg = (loading)?'Loading ...':'Error!';
		return (
			<Template
				loading = { loading }
				cols = { cols }
			>
				<Form.Control
					as="select"
					style = {{width: '15em'}}
					disabled = { true }
				>
					<option
						key = {-1}
						value = {''}
					>{ msg }</option>
				</Form.Control>
			</Template>
		)
	} else {
		return (
			<Template
				loading = { loading }
				cols = { cols }
			>
				<Form.Control
					as="select"
					onChange = {(evt)=>handleChange(evt)}
					value = { value }
					style = {{width: '15em'}}
					disabled = { (session.SessionID < 1) }
				>
					<option
						key = {-1}
						value = { today }
					>{ 'Current' }</option>
					{ columns.map((row, idx) =>{
						return (
							<option
								key = {idx}
								value = {row}
							>{ row }</option>
						)
					})
				}
				</Form.Control>
			</Template>
		)
	}
}

const Template = (props) => (
	<Row className="inputRow">
		<Col sm = { props.cols.lhs }> <label className="dropdownLabel">Historical for week ending:</label></Col>
		<Col sm = { props.cols.rhs }>
			{ props.children }
			<Loading loading = { props.loading } size = {'sm'} />
		</Col>
	</Row>
)

const actionFetchLastDayOfWkData = (session, showMessage, setLoading) => {
	//console.log('running actionFetchLastDayOfWkData()')
	let resp = []
	const params = {
		params: {
			sessionId: session.SessionID,
		},
		headers: {
			'x-opw-format': 'list',
		}
	}
	return API.get(URL_SESSION_LAST_DAY_OF_WK, params)
	.then(response => {
		//console.log('actionFetchLastDayOfWkData() response.data',response.data)
		resp = response.data
	})
	.catch(error => {
		//throw(error);
		showMessage('Error fetching last day of week data: ' + error)
	})
	.then (() => {
		setLoading(false)
		return resp
	});
};